<div class="body-container">
  <div class="header-container">
    <app-header (sidebarStatusEmit)="setSidebarStatus($event)"></app-header>
  </div>
  <div class="content-container">
    <router-outlet></router-outlet>
    <div class="superadmin-header" *ngIf="currentSuperAdmin">
      You are {{currentSuperAdmin.name}} logged in as {{loggedInUser?.name}}. <a routerLink="/impersonate/out">Click here to stop impersonation.</a>
    </div>
  </div>
  <div class="sidebar-container">
    <app-sidebar [sidebarStatus]="sidebarStatus"></app-sidebar>
  </div>
</div>
